import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  Button,
  Stack
} from "@mui/material";

import api from "../../api/api";

export default function LeaveApprovals() {

  const [leaves, setLeaves] = useState([]);

  useEffect(() => {
    loadLeaves();

    // ------------------------------------------------
    // AUTO REFRESH every 20 seconds
    // ------------------------------------------------
    const interval = setInterval(loadLeaves, 20000);

    return () => clearInterval(interval);

  }, []);

  // ==========================================
  // LOAD PENDING LEAVES
  // ==========================================

  const loadLeaves = async () => {

    try {

      const res = await api.get("/leaves/pending");

      setLeaves(res.data);

    } catch (error) {

      console.error("Error loading approval leaves", error);

    }

  };

  // ==========================================
  // APPROVE LEAVE
  // ==========================================

  const approveLeave = async (id) => {

    try {

      await api.put(`/leaves/${id}/approve`);

      loadLeaves();

    } catch (error) {

      console.error("Approve failed", error);

    }

  };

  // ==========================================
  // REJECT LEAVE
  // ==========================================

  const rejectLeave = async (id) => {

    try {

      await api.put(`/leaves/${id}/reject`);

      loadLeaves();

    } catch (error) {

      console.error("Reject failed", error);

    }

  };

  // ==========================================
  // STATUS CHIP
  // ==========================================

  const statusChip = (status) => {

    if (status === "PENDING_PM")
      return <Chip label="Pending PM" color="warning" size="small" />;

    if (status === "PENDING_HR")
      return <Chip label="Pending HR" color="warning" size="small" />;

    if (status === "PENDING_ADMIN")
      return <Chip label="Pending Admin" color="warning" size="small" />;

    if (status === "APPROVED")
      return <Chip label="Approved" color="success" size="small" />;

    if (status === "REJECTED")
      return <Chip label="Rejected" color="error" size="small" />;

    return <Chip label={status} size="small" />;

  };

  return (

    <Box p={4}>

      <Typography variant="h5" mb={3}>
        Leave Approvals
      </Typography>

      <Card>

        <CardContent>

          <Table>

            <TableHead>

              <TableRow>

                <TableCell>User</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Start</TableCell>
                <TableCell>End</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>

              </TableRow>

            </TableHead>

            <TableBody>

              {leaves.length === 0 && (

                <TableRow>
                  <TableCell colSpan={6}>
                    No pending approvals
                  </TableCell>
                </TableRow>

              )}

              {leaves.map((leave) => (

                <TableRow key={leave.id}>

                  <TableCell>
                    {leave.user_name}
                  </TableCell>

                  <TableCell>
                    {leave.leave_type}
                  </TableCell>

                  <TableCell>
                    {new Date(leave.start_date).toLocaleDateString()}
                  </TableCell>

                  <TableCell>
                    {new Date(leave.end_date).toLocaleDateString()}
                  </TableCell>

                  <TableCell>
                    {statusChip(leave.status)}
                  </TableCell>

                  <TableCell>

                    <Stack direction="row" spacing={1}>

                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={() => approveLeave(leave.id)}
                      >
                        Approve
                      </Button>

                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => rejectLeave(leave.id)}
                      >
                        Reject
                      </Button>

                    </Stack>

                  </TableCell>

                </TableRow>

              ))}

            </TableBody>

          </Table>

        </CardContent>

      </Card>

    </Box>

  );

}